import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { getMtaApBasicData, hydrateApBasicData } from './helpers/basicHelper';
import { addDNoneClass, byId } from './helpers/utility';





authHelper.validate();
hydrateApBasicData();
// checking query params for transition result alert


const minimumDepositInput = byId('minimumDepositInput');
const maximumDepositInput = byId('maximumDepositInput');
const minimumWithdrawalInput = byId('minimumWithdrawalInput');
const maximumWithdrawalInput = byId('maximumWithdrawalInput');
const withdrawalChargeInPercentageInput = byId('withdrawalChargeInPercentageInput');
const activePaymentGatewayInput = byId('activePaymentGatewayInput');
const paytmMerchantIdInput = byId('paytmMerchantIdInput');
const paytmMerchantKeyInput = byId('paytmMerchantKeyInput');
const paytmCustomInputDiv = byId('paytmCustomInputDiv');

const pgDataOneInputDiv = byId('pgDataOneInputDiv');
const pgDataOneInput = byId('pgDataOneInput');
const pgDataOneInputLabel = byId('pgDataOneInputLabel');


const cdcNoteSpan = byId('cdcNoteSpan');

const walletSettingsSubmitBtn = byId('walletSettingsSubmitBtn');
const walletSettingsEditBtn = byId('walletSettingsEditBtn');

 

const walletSettings = {
    get: async () => {

        try {
            const response = await callTheApServerGet(`/basic/getWalletConfig`);
            axiosResponseHandler(response);
            const res = response.data;

            if (res.status === 'success') {
                console.log(res);


                const { minimumDeposit, maximumDeposit, minimumWithdrawal, maximumWithdrawal, withdrawalChargeInPercentage, activePaymentGateway, paytmMerchantId, paytmMerchantKey, pg_data1 } = res.walletConfigData;

                if (activePaymentGateway == 'upiSemiAutomatic') {
                    pgDataOneInput.value = pg_data1;

                } else if (activePaymentGateway == 'cdcWebPaytm') {
                    pgDataOneInput.value = pg_data1;

                }

                minimumDepositInput.value = minimumDeposit;
                maximumDepositInput.value = maximumDeposit;
                minimumWithdrawalInput.value = minimumWithdrawal;
                maximumWithdrawalInput.value = maximumWithdrawal;
                withdrawalChargeInPercentageInput.value = withdrawalChargeInPercentage;
                activePaymentGatewayInput.value = activePaymentGateway;
                paytmMerchantIdInput.value = paytmMerchantId;
                paytmMerchantKeyInput.value = paytmMerchantKey;



                walletSettings.onActivePaymentGatewayChange();

            }
        } catch (error) {
            axiosErrorHandler(error);
            console.log(error);
        }
    },
    edit: () => {
        minimumDepositInput.disabled = maximumDepositInput.disabled = minimumWithdrawalInput.disabled = maximumWithdrawalInput.disabled = withdrawalChargeInPercentageInput.disabled = activePaymentGatewayInput.disabled = paytmMerchantIdInput.disabled = paytmMerchantKeyInput.disabled = false;
        pgDataOneInput.disabled = false;
        addDNoneClass(walletSettingsSubmitBtn, false);
        addDNoneClass(walletSettingsEditBtn, true);
    },
    submit: async () => {

        let pgDataOne = '';
        if (activePaymentGatewayInput.value == 'upiSemiAutomatic') {
            pgDataOne = pgDataOneInput.value;
        } else if (activePaymentGatewayInput.value == 'cdcWebPaytm') {
            pgDataOne = pgDataOneInput.value;
        }

        const data = {
            minimumDeposit: minimumDepositInput.value,
            maximumDeposit: maximumDepositInput.value,
            minimumWithdrawal: minimumWithdrawalInput.value,
            maximumWithdrawal: maximumWithdrawalInput.value,
            withdrawalChargeInPercentage: withdrawalChargeInPercentageInput.value,
            activePaymentGateway: activePaymentGatewayInput.value,
            paytmMerchantId: paytmMerchantIdInput.value,
            paytmMerchantKey: paytmMerchantKeyInput.value,
            pg_data1: pgDataOne

        };
        callTheApServerPost(`/basic/updateWalletConfig`, { data }).then((response) => {
            axiosResponseHandler(response);
            const res = response.data;






            if (res.status === 'success') {
                console.log(res);


                Swal.fire({
                    title: 'walletSettings Updated',
                    icon: 'success',
                    showConfirmButton: false,


                    allowOutsideClick: false,


                });

                setTimeout(() => {
                    location.reload();
                }, 3000);



            }
        }).catch((error) => {
            axiosErrorHandler(error);
            console.log(error);
        });

    },
    onActivePaymentGatewayChange: () => {
        addDNoneClass(paytmCustomInputDiv, true);
        addDNoneClass(pgDataOneInputDiv, true);
        addDNoneClass(cdcNoteSpan, true);
 
        const activePlan = getMtaApBasicData().activePlan;

        if(activePlan ==='free'){
            activePaymentGatewayInput.value = 'none';
            // error 
            Swal.fire({
                title: 'Disabled',
                icon: 'error',
                text: 'All Payment Getway are disabled in Free App'



            });
            return false;
        }

        if (activePaymentGatewayInput.value === 'paytmCustom') {


           

            addDNoneClass(paytmCustomInputDiv, false);

        } else if (activePaymentGatewayInput.value === 'upiSemiAutomatic') {
            

        

            pgDataOneInputLabel.innerText = 'Upi Id/ VPA';
            addDNoneClass(pgDataOneInputDiv, false);
        } else if (activePaymentGatewayInput.value === 'cdcWebPaytm') {

     


            pgDataOneInputLabel.innerText = 'Production Api Token';
            addDNoneClass(pgDataOneInputDiv, false);
            addDNoneClass(cdcNoteSpan, false);
        }
    }
};

window.walletSettings = walletSettings;
walletSettings.get();
walletSettings.onActivePaymentGatewayChange();


const nameInput = byId('nameInput');
const titleInput = byId('titleInput');
const idExampleInput = byId('idExampleInput');
const withdrawalMethodsTableNoDataRowElement = byId('withdrawalMethodsTableNoDataRowElement');
const withdrawalMethodsTableBodyElement = byId('withdrawalMethodsTableBodyElement');


const withdrawalMethods = {
    addNew: async () => {

        const data = {
            name: nameInput.value,
            title: titleInput.value,
            idExample: idExampleInput.value,


        };
        callTheApServerPost(`/basic/addNewWithdrawalMethod`, { data }).then((response) => {
            axiosResponseHandler(response);
            const res = response.data;






            if (res.status === 'success') {
                console.log(res);


                Swal.fire({
                    title: 'Withdraw method   added ',
                    icon: 'success',
                    showConfirmButton: false,


                    allowOutsideClick: false,


                });

                setTimeout(() => {
                    location.reload();
                }, 3000);



            }
        }).catch((error) => {
            axiosErrorHandler(error);
            console.log(error);
        });

    },
    get: async () => {


        try {
            const response = await callTheApServerGet(`/basic/getWithdrawalMethods`);
            axiosResponseHandler(response);
            const res = response.data;






            if (res.status === 'success') {
                console.log(res);




                if (res.withdrawalMethodsData.length > 0) {

                    addDNoneClass(withdrawalMethodsTableNoDataRowElement, true);

                    let i = 0;
                    while (i < res.withdrawalMethodsData.length) {
                        const { sn, name, title, idExample } = res.withdrawalMethodsData[i];

                        withdrawalMethodsTableBodyElement.innerHTML += `
                        <tr>
                        
                            <td>${i + 1}</td>
                          
                            <td>${name}</td>
                            <td>${title}</td>
                            <td>${idExample}</td>
                         
                            <td><button class="btn btn-danger" onclick="withdrawalMethods.delete(${JSON.stringify({ sn }).split('"').join('&quot;')})" >Delete</button></td>
                          
                        </tr>
                        `;
                        i++;
                    }
                } else {
                    withdrawalMethodsTableNoDataRowElement.innerHTML = `
                    <th class='text-center' colspan='5'>No Withdrawal Method Found 😥</th> 
                    `;
                }





            }

        } catch (error) {
            axiosErrorHandler(error);
            console.log(error);
        }
    },
    delete: async ({ sn }) => {


        try {
            const response = await callTheApServerGet(`/basic/deleteWithdrawalMethod/${sn}`);
            axiosResponseHandler(response);
            const res = response.data;

            if (res.status === 'success') {
                console.log(res);


                Swal.fire({
                    title: 'withdraw method Deleted',
                    icon: 'success',
                    showConfirmButton: false,


                    allowOutsideClick: false,


                });

                setTimeout(() => {
                    location.reload();
                }, 3000);



            }
        } catch (error) {
            axiosErrorHandler(error);
            console.log(error);
        }

    },
};

window.withdrawalMethods = withdrawalMethods;




withdrawalMethods.get();
